module.exports = __webpack_public_path__ + "static/img/20014 (3).d7f594b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20014 (3).webp
// module id = P0QS
// module chunks = 14